export default {
  common: {
    currentLanguage: 'The current language is "{{lng}}"',
    no_internet_connection: "Es besteht keine Internetverbindung!",
    loading: "Laden...",
    database_not_loaded: "Datenbank wird nicht geladen",
    developed_by: "App-Entwicklung:",
    in_cooperation_with: "in Kooperation mit:"
  },

  regions: {
    push_tips_infos: "Wachstipps und Produktinfos erhalten",
    push_history_link: "Push-Benachrichtigungen"
  },

  sportTypes: {
    screen_title: "Sportart"
  },

  sportVariants: {
    screen_title: "Sport-Variante"
  },

  parameters: {
    screen_title: "Parameter",
    temperature: "Temperatur",
    air_humidity: "Luftfeuchtigkeit",
    snow_type: "Schneeart",
    snow_types: {
      1: "Neuschnee <24h",
      2: "Veränderter Schnee >24h",
      3: "Firn- und Altschnee",
      4: "Kunstschnee"
    },
    show_results: "Ergebnis anzeigen"
  },

  results: {
    screen_title: "Ergebnis",
    no_results: "Keine Ergebnisse für ausgewählte Parameter",
    layers: {
      layer_1: "1. Schicht",
      layer_2: "2. Schicht",
      layer_3: "3. Schicht"
    },
    protip: "Profitipp"
  },

  products: {
    button_wishlist: "Merkliste",
    button_remove_from_wishlist: "Aus dem Wunschzettel entfernen",
    button_video: "Video",
    button_buynow: "Bestellen"
  },

  weather: {
    screen_title: "Wetter",
    select_country: "Land auswählen",
    cancel: "Abbrechen",
    no_providers: "Keine Wetter Providers"
  },

  wishlist: {
    screen_title: "Merkliste",
    no_products: "Es befinden sich keine Produkte auf Ihrer Merkliste",
    send_to_email: "Merkliste per E-Mail versenden",
    email_placeholder: "Ihre E-Mailadresse",
    button_send: "Senden",
    button_cancel: "Abbrechen",
    send_to_email_success:
      "Ihre Merkliste wurde erfolgreich an die eingegebene E-Mail-Adresse gesendet"
  },

  settings: {
    screen_title: "Einstellungen",
    app_name: "HWK Skiwachsberater",
    app_version: "App-Version",
    db_version: "Letzte Datenbankaktualisierung",
    refresh_database: "Datenbank aktualisieren",
    button_impressum: "Impressum",
    button_privacy: "Datenschutz",
    button_website: "Webseite",
    button_reset_settings: "Alle Einstellungen zurücksetzen",
    action_reset_all: "Alle Einstellungen zurücksetzen",
    action_reset_cancel: "Abbrechen",
    action_are_you_sure: "Bist du sicher?",    
    new_update_available: "Neues App-Update verfügbar. Es wird in Kürze heruntergeladen und installiert.",
    already_updated: "Sie haben bereits die neueste App-Version.",
  },

  notifications: {
    screen_title: "Benachrichtigungen",
    delete: "Löschen",
    no_notifications: "Es gibt keine neuen Benachrichtigungen"
  }
};
